<template>
  <div>
    <div id="idItemListList">
      <b-row>
        <b-col
          cols="12"
        >
          <b-table
            ref="refItemTable"
            thead-class="itemTableHeader"
            tbody-tr-class="itemTableRow"
            primary-key="id"
            responsive
            show-empty
            striped
            hover
            empty-text="Não há itens cadastrados."
            :items="items"
            :fields="tableColumns"
            :sort-by.sync="sortBy"
            :sort-desc.sync="isSortDirDesc"
            :busy="isLoading"
          >
            <template #table-busy>
              <div class="text-center my-3">
                <b-spinner
                  variant="info"
                  class="align-middle mb-1"
                />
                <br>
                <strong class="pt-2">Carregando...</strong>
              </div>
            </template>
            <template #cell(field_lote)="field">
              <b-media vertical-align="center">
                <span
                  v-if="field.item.parent_set"
                  class="font-weight-bold d-block text-nowrap"
                >
                  {{ field.item.parent_set.name }}
                </span>
                <span
                  v-else
                  class="font-weight-bold d-block text-nowrap"
                >
                  -
                </span>
              </b-media>
            </template>

            <template #cell(field_type)="field">
              <b-media vertical-align="center">
                <span
                  class="font-weight-bold d-block text-nowrap"
                >
                  <svg-icon
                    v-if="field.item.type === 'unit'"
                    class="d-inline-block itemIconType ml-50"
                    type="mdi"
                    :path="mdiAlphaUBoxOutline"
                  />
                  <svg-icon
                    v-if="field.item.type === 'compound'"
                    class="d-inline-block itemIconType ml-50"
                    type="mdi"
                    :path="mdiAlphaCBox"
                  />
                </span>
              </b-media>
            </template>

            <template #cell(field_name)="field">
              <b-media vertical-align="center">
                <span
                  class="font-weight-bold d-block text-nowrap"
                >
                  {{ field.item.name }}
                </span>
              </b-media>
            </template>

            <template #cell(field_qtd)="field">
              <b-media vertical-align="center">
                <span
                  class="font-weight-bold d-block text-nowrap"
                >
                  {{ field.item.quantity }}
                </span>
              </b-media>
            </template>

            <template #cell(field_brand)="field">
              <b-media vertical-align="center">
                <span
                  class="font-weight-bold d-block text-nowrap"
                >
                  {{ field.item.product_list[0].product_set.brand }}
                </span>
              </b-media>
            </template>

            <template #cell(field_model)="field">
              <b-media vertical-align="center">
                <span
                  class="font-weight-bold d-block text-nowrap"
                >
                  {{ field.item.product_list[0].product_set.model }}
                </span>
              </b-media>
            </template>

            <template #cell(field_sale_value)="field">
              <b-media vertical-align="center">
                <span
                  class="font-weight-bold d-block text-nowrap"
                >
                  R$ {{ field.item.price | formatCurrency() }}
                </span>
              </b-media>
            </template>

            <template #cell(field_cost_total)="field">
              <b-media vertical-align="center">
                <span
                  class="font-weight-bold d-block text-nowrap"
                >
                  R$ {{ field.item.price * field.item.quantity | formatCurrency() }}
                </span>
              </b-media>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BTable,
  BMedia,
  VBTooltip,
  BSpinner,
} from 'bootstrap-vue'

import {
  mdiAlphaUBoxOutline,
  mdiAlphaCBox,
} from '@mdi/js'

import SvgIcon from '@jamescoyle/vue-icon'
import formValidation from '@core/comp-functions/forms/form-validation'
import formatCurrency from '@/components/utils/filters/formatCurrency'
import syslic from '@/syslic'
import router from '@/router'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BMedia,
    SvgIcon,
    BSpinner,
  },
  filters: {
    formatCurrency,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    bidding: {
      type: [String, Number],
      required: true,
    },
    readonly: {
      type: [Boolean],
      required: true,
    },
  },
  data() {
    const isLoading = true

    const {
      refFormObserver,
      getValidationState,
    } = formValidation(this.data)

    const sortBy = 'name'
    const isSortDirDesc = false
    const tableColumns = [
      {
        key: 'field_lote',
        label: 'lote',
        thStyle: { minWidth: '6rem' },
      },
      {
        key: 'field_type',
        label: 'Tipo',
        thStyle: { minWidth: '6rem' },
      },
      {
        key: 'field_name',
        label: 'Nome do produto na licitação',
        thStyle: { minWidth: '24rem' },
      },
      {
        key: 'field_qtd',
        label: 'Quantidade registrada',
        thStyle: { minWidth: '18rem' },
      },
      {
        key: 'field_brand',
        label: 'Marca',
        thStyle: { minWidth: '10rem' },
      },
      {
        key: 'field_model',
        label: 'Modelo',
        thStyle: { minWidth: '10rem' },
      },
      {
        key: 'field_sale_value',
        label: 'Valor de venda',
        thStyle: { minWidth: '18rem' },
      },
      {
        key: 'field_cost_total',
        label: 'Valor Total',
        thStyle: { minWidth: '20rem' },
      },
    ]

    const items = []

    return {
      refFormObserver,
      getValidationState,
      isLoading,
      sortBy,
      tableColumns,
      isSortDirDesc,
      items,
    }
  },
  created() {
    this.fetchItemsList()
  },
  methods: {
    fetchItemsList() {
      this.isLoading = true

      syslic
        .bidding
        .fetchBidding(this.bidding)
        .then(response => {
          this.items = response.data.items_set
          this.isLoading = false
          this.$refs.refItemTable.refresh()
          this.$emit('ready', true)
        })
        .catch(err => {
          if (err.status === 404) {
            router.push({ name: 'error-404' })
          }
          this.isLoading = false
          this.$emit('ready', true)
        })
    },
  },
  setup() {
    return {
      mdiAlphaUBoxOutline,
      mdiAlphaCBox,
    }
  },
}
</script>
<style lang="scss">
@import "@core/scss/base/core/colors/palette-variables.scss";

#idItemListList .itemTableHeader th {
  color: $primary;
  font-weight: 600;
  font-size: 0.9rem;
  background-color: $light-blue;
}

#idItemListList .itemTableRow {
  cursor: default;
}

#idItemListList .itemIconType {
  color: $primary;
}
</style>
